import { Route, Routes } from "react-router-dom"
import AdminUserList from "./components/AdminUserList"

export default function AdminUsersPage() {
  return (
    <Routes>
      <Route index element={<AdminUserList />} />
    </Routes>
  )
}
